import { ArrowRight } from 'lucide-react';
import { T } from '../i18n/copy';

// One slow editorial marquee — the operating method crossing the boundary
// between the warm passage and the dark authority passage.
export default function Marquee({ lang }) {
  const words = T.marquee.words[lang];
  const tag = T.marquee.tag[lang];
  const Row = ({ hidden }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {words.map((w) => (
        <span key={w} className="flex items-center">
          <span className="eyebrow px-6 text-bone/80">{w}</span>
          <ArrowRight className="h-3.5 w-3.5 text-vermilion" strokeWidth={1.5} />
        </span>
      ))}
      <span className="eyebrow px-6 text-bone/45">{tag}</span>
      <span className="h-1 w-1 rounded-full bg-vermilion/70" />
    </div>
  );
  return (
    <div data-header-theme="midnight" data-testid="marquee-strip" className="overflow-hidden border-y border-bone/10 bg-midnight py-4">
      <div className="marquee-track flex w-max">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
